export type FileStatusValue = boolean | null;

/** Tooltips da legenda (modal Detalhes) — explicam a coluna */
export const FILE_STATUS_COLUMN_TOOLTIPS = {
  save: 'Arquivo .cdr salvo no sistema',
  export: 'Exportação para impressão',
  layout: 'Exportação de layout',
} as const;

/** Tooltips curtos por ícone (estado atual) */
export const FILE_STATUS_STATE_TOOLTIPS = {
  save: {
    true: 'Salvo',
    false: 'Não salvo',
    unknown: 'Salvamento ?',
  },
  export: {
    true: 'Impressão ok',
    false: 'Impressão pendente',
    unknown: 'Impressão ?',
  },
  layout: {
    true: 'Layout ok',
    false: 'Layout pendente',
    unknown: 'Layout ?',
  },
} as const;

export const FILE_STATUS_GROUP_TOOLTIP = 'Arquivo · impressão · layout';

export function getFileStatusStateTooltip(
  kind: keyof typeof FILE_STATUS_STATE_TOOLTIPS,
  value: FileStatusValue
): string {
  const labels = FILE_STATUS_STATE_TOOLTIPS[kind];
  if (value === true) return labels.true;
  if (value === false) return labels.false;
  return labels.unknown;
}
